import { RotateCw } from 'lucide-react';
import { setFoulsOnPeriod } from 'modules/overlay-v2/store/game-info/game-info';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { theme } from 'styles/theme/theme';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import useTime from 'modules/overlay-v2/ui/hooks/use-time';
import Block from '../components/block';
import Counter from '../components/counter';

export function Fouls() {
  const dispatch = useDispatch<AppDispatch>();
  const { fouls } = useGameInfo();
  const { period } = useTime();

  const setScoreFirstTeam = (num: number) => {
    dispatch(setFoulsOnPeriod({ first: num, period }));
  };

  const setScoreSecondTeam = (num: number) => {
    dispatch(setFoulsOnPeriod({ second: num, period }));
  };

  const onClickReset = () => {
    dispatch(setFoulsOnPeriod({ first: 0, second: 0, period }));
  };

  return (
    <Block className={'flex-center flex-col'} headerText={'Фолы'}>
      <div className={'flex'} style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <Counter value={fouls.first} setValue={setScoreFirstTeam} />
        <RotateCw size={16} color={theme.colors.WhiteGray} onClick={onClickReset} />
        <Counter value={fouls.second} setValue={setScoreSecondTeam} />
      </div>
    </Block>
  );
}
